export default __webpack_public_path__ + "static/Fazenda_California-73f41b872ff468a894117c3204135b17.webp";